import React, { useEffect, useState } from "react";
import { FiAlignJustify } from "react-icons/fi";
import { IoIosClose } from "react-icons/io";

const Nav2 = () => {
    const [navbarMobile, setNavbarMobile] = useState(false);
    const [iconClass, setIconClass] = useState('bi-list');

    useEffect(() => {



        const navbarlinks = document.querySelectorAll('#navbar .scrollto');

        const navbarlinksActive = () => {
            let position = window.scrollY + 200;
            navbarlinks.forEach(navbarlink => {
                if (!navbarlink.hash) return;
                let section = document.querySelector(navbarlink.hash);
                if (!section) return;
                if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
                    navbarlink.classList.add('active');
                } else {
                    navbarlink.classList.remove('active');
                }
            });
        };

        window.addEventListener('load', navbarlinksActive);
        window.addEventListener('scroll', navbarlinksActive);

        return () => {
            window.removeEventListener('load', navbarlinksActive);
            window.removeEventListener('scroll', navbarlinksActive);
        };
    }, []);

    const handleToggle = () => {
        setNavbarMobile(!navbarMobile);
        setIconClass(navbarMobile ? 'bi-list' : 'bi-x');
    };

    return (
        <header id="header" className='fixed-top header-scrolled' style={{ backgroundColor: 'black' }}
        >
            <div className="container d-flex align-items-center justify-content-between">
                <h1 className="logo">
                    <a href="/">.Mateu Joan</a>
                </h1>

                <nav id="navbar" className={`navbar ${navbarMobile ? 'navbar-mobile' : ''}`}>
                    <ul>
                        <li><a className="nav-link scrollto" href="/">Home</a></li>
                        <li><a className="nav-link scrollto" href="/#about">Sobre mi</a></li>
                        <li><a className="nav-link scrollto" href="/">PortFolio</a></li>
                        <li><a className="nav-link scrollto" href="/">Contacto</a></li>
                    </ul>
                    <i className={`bi mobile-nav-toggle ${iconClass}`} onClick={handleToggle}>
                        {iconClass === 'bi-list' ? <FiAlignJustify /> : <IoIosClose />}
                    </i>
                </nav>
            </div>
        </header>
    );
};

export default Nav2;
